import { Badge, Panel } from '../../components/kit'
import { useAuth } from '../../contexts/AuthProvider'
import { PreferenciaTema, useTema } from '../../stores/temaStore'
import { formatoFecha } from '../../utils/fecha'

const TEMAS: { valor: PreferenciaTema; texto: string }[] = [
  { valor: 'claro', texto: 'Claro' },
  { valor: 'oscuro', texto: 'Oscuro' },
  { valor: 'sistema', texto: 'Como el sistema' },
]

export default function Perfil() {
  const { user } = useAuth()
  const { preferencia, elegir } = useTema()
  const persona = user?.persona

  return (
    <div className="pila pila--amplia">
      <header className="pagina__cabecera">
        <h1 className="dcc-t-heading-m">Mi perfil</h1>
      </header>

      <div className="grilla">
        <Panel titulo="Persona">
          {persona ? (
            <dl className="datos">
              <dt>Nombre</dt>
              <dd>{persona.nombre}</dd>
              <dt>RUT</dt>
              <dd>{persona.rut_formateado || '—'}</dd>
              <dt>Correo</dt>
              <dd>{persona.email || '—'}</dd>
              <dt>Datos de UCampus (Puente)</dt>
              <dd>{persona.sincronizado_puente ? formatoFecha(persona.sincronizado_puente) : <Badge>Nunca sincronizados</Badge>}</dd>
            </dl>
          ) : (
            <p className="texto-secundario">Esta cuenta no está enlazada a una persona (no tiene RUT asociado).</p>
          )}
        </Panel>

        <Panel titulo="Preferencias">
          <fieldset className="opciones">
            <legend className="dcc-field__label">Tema</legend>
            {TEMAS.map((t) => (
              <label className="dcc-control" key={t.valor}>
                <input type="radio" name="tema" checked={preferencia === t.valor} onChange={() => elegir(t.valor)} />
                <span className="dcc-dot" />
                <span>{t.texto}</span>
              </label>
            ))}
          </fieldset>
        </Panel>
      </div>
    </div>
  )
}
